import { ReturnMethodType } from "@redotech/redo-return-core-common/return-method";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum ReturnMethodFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const ReturnMethodFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.RETURN_METHOD,
  ReturnMethodFilterQuery,
  z.array(createEnum(ReturnMethodType)),
);
export const ReturnMethodFilterSchema: z.ZodType<ReturnMethodFilter> =
  ReturnMethodFilterSchema_;
export interface ReturnMethodFilter extends z.infer<
  typeof ReturnMethodFilterSchema_
> {}

/**
 * Maps selected methods onto the values the returned line items report renders,
 * where ERROR is displayed as SHIPMENT.
 */
export function returnMethodValuesAsRendered(
  values: readonly ReturnMethodType[],
): ReturnMethodType[] {
  const rendered = new Set<ReturnMethodType>(values);
  rendered.delete(ReturnMethodType.ERROR);
  if (rendered.has(ReturnMethodType.SHIPMENT)) {
    rendered.add(ReturnMethodType.ERROR);
  }
  return [...rendered];
}
